import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  height: 100%;
  padding: 20.5px 0;
`

export const Ellipse = styled.div`
  position: relative;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  &.spaced-from-border {
    position: relative;
    top: 6px;
    left: 2px;
  }
  &.outlined {
    border: 1px solid ${props => props.theme.colors.color378ff7};
    background: ${({ theme }) => theme.zds.colors.neutral1000};
  }

  &.filled {
    background: ${props => props.theme.colors.color005597};
  }
`
